import {storage, StorageKeys} from '../storage';

const cache = new Map<StorageKeys, unknown>();

export const hydrateStorageKeys = async (keys: StorageKeys[]): Promise<void> => {
  await Promise.all(
    keys.map(async (key) => {
      cache.set(key, await storage.getItem(key));
    }),
  );
};

export const getHydratedItem = <T>(key: StorageKeys): T | null => {
  if (!cache.has(key)) return null;
  return (cache.get(key) as T | null) ?? null;
};

export const setHydratedItem = async <T>(key: StorageKeys, value: T): Promise<void> => {
  cache.set(key, value);
  await storage.setItem(key, value);
};

export const removeHydratedItem = async (key: StorageKeys): Promise<void> => {
  cache.set(key, null);
  await storage.removeItem(key);
};
